import * as React from 'react'

import './styles.scss'

export default function Spinner() {
  return (
    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
  )
}
